import './Footer.css'

function Footer() {
    return (
        <div className='footer-container'>
            <p>Copyright (c) 2021<span>PAB Web Designs</span></p>
        </div>
    )
}

export default Footer
